import React from "react";
import { Box, Typography, Container, Link, IconButton, Grid2, Paper, TextField, Button } from "@mui/material";
import { Facebook, Twitter, LinkedIn } from "@mui/icons-material";

const Footer = () => {
  return (
    <Box bgcolor="primary.main" color="primary.contrastText" py={4}
      sx={{
        boxSizing: "border-box",
        //color: "rgb(203, 203, 203)",
        cursor: "pointer",
        display: "block",
        fontFamily: "Inter, sans-serif",
        fontSize: "20px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "30px",
        textAlign: "left",
        textTransform: "none",
        visibility: "visible",
        //  WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      }}
    >
      <Container maxWidth="lg">
        {/*  <Grid2 container spacing={4}>
          {/* First Row: Why Choose Us and Contact Form /}
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Box mb={4}>
              <Typography variant="h5" gutterBottom sx={{ fontSize: "2rem" }}>
                Why Choose Us
              </Typography>
              <Typography variant="body1" paragraph sx={{ fontSize: "1.5rem" }}>
                Maximus stands out for its unwavering commitment to quality and reliability in electrical testing services.
                With a team of certified professionals, we ensure that every system is inspected and maintained to perfection.
              </Typography>
              <Typography variant="body1" paragraph sx={{ fontSize: "1.5rem" }}>
                Client satisfaction is at the heart of everything we do at Maximus.
                We offer personalized service, quick response times, and full transparency on every project.
                Whether it's routine maintenance or emergency troubleshooting, our support never sleeps.
                Choose Maximus for trusted expertise and continuous power system integrity.
              </Typography>
            </Box>
          </Grid2>

          {/* Second Row: Quick Links and Contact Section /}
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Paper elevation={3} sx={{ padding: 3, bgcolor: "white" }}>
              <Typography variant="h5" gutterBottom sx={{ color: "black" }}>
                Contact Us
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{ color: "black" }}
              >
                Fill out the form below to get more detailed information about our services, solutions, and offerings.
                We're here to help you with your asset management needs.
              </Typography>


              Contact Form
              <Box component="form" noValidate autoComplete="on" sx={{ mt: 2 }}>
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <TextField fullWidth label="Name *" variant="outlined" required />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <TextField fullWidth label="Email Address *" variant="outlined" required />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <TextField fullWidth label="Phone Number *" variant="outlined" required />
                  </Grid2>
                  <Grid2 size={{ xs: 12 }}>
                    <TextField
                      fullWidth
                      label="Message"
                      variant="outlined"
                      multiline
                      rows={4}
                      required
                    />
                  </Grid2>
                </Grid2>

                <Box sx={{ textAlign: "center", mt: 2 }}>
                  <Button variant="contained" color="secondary" type="submit">
                    Send Message
                  </Button>
                </Box>
              </Box>
            </Paper>
          </Grid2>
        </Grid2> */}

        {/* Footer Links */}
        <Box display="flex" justifyContent="space-between" flexWrap="wrap" mt={4}>
          {/* Quick Links */}
          <Box mb={2} flex={1}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            {["Home", "About", "Services", "Contact", "Privacy Policy", "Terms and Conditions", "Login"].map(
              (link, index) => (
                <Typography key={index} sx={{ marginBottom: 1 }}>
                  <Link
                    href={`/${link.toLowerCase().replace(/\s+/g, "-")}`}
                    color="inherit"
                    underline="hover"
                    sx={{
                      boxSizing: "border-box",
                      //color: "rgb(203, 203, 203)",
                      cursor: "pointer",
                      display: "block",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "20px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "30px",
                      textAlign: "left",
                      textTransform: "none",
                      visibility: "visible",
                      //  WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                    }}
                  >
                    {link}
                  </Link>
                </Typography>
              )
            )}
          </Box>

          {/* Contact Info Section */}
          <Box mb={2} flex={1}>
            <Typography variant="h5" gutterBottom>
              📩 Contact Us
            </Typography>
            <Typography variant="body1">
              <strong>Maximus Integrated Services</strong>
              <br />
              <strong>Reg Office:</strong> No: 347 B-First Floor, 6th Street,
              <br /> Sivaramakrishna nagar, Periya Kolathuvancherry, Iyyappanthangal, Chennai -600056.
              <br />
              <br />
              <strong>Resource Persons :</strong> Mr.Bharath Arun & Mr.Satheesh Kumar<br />
              <strong>Phone:</strong> +91 72002 98103, +91 72002 98102
              <br />
              <strong>Email:</strong>{" "}
              <Link href="mailto:maximus@maximuss.in" color="inherit">
                maximus@maximuss.in
              </Link>
              <br />
              <Link href="mailto:maximus2022.mis@gmail.com" color="inherit">
                maximus2022.mis@gmail.com
              </Link>
            </Typography>
          </Box>

          {/* Follow Us Section */}
          <Box mb={2} flex={1}>
            <Typography variant="h6" gutterBottom>
              Follow Us
            </Typography>
            <Box display="flex" gap={1}>
              <IconButton href="#" color="inherit">
                <Facebook />
              </IconButton>
              <IconButton href="#" color="inherit">
                <Twitter />
              </IconButton>
              <IconButton href="#" color="inherit">
                <LinkedIn />
              </IconButton>
            </Box>
          </Box>
        </Box>

        {/* Copyright Section */}
        <Box textAlign="center" mt={4}>
          <Typography variant="body2">
            &copy; {new Date().getFullYear()} Maximus Integrated Services. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
